/* eslint-disable vars-on-top */
/* eslint-disable import/no-duplicates */
/* eslint-disable no-var */
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import React, { useState, useContext } from 'react';
import { Avatar, Spin } from 'antd';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import FeatherIcon from 'feather-icons-react';
import { PulseLoader } from 'react-spinners';
import { InfoWraper, NavAuth, UserDropDwon } from './auth-info-style';
import Message from './message';
import Notification from './notification';
import Settings from './settings';
import Support from './support';
import NewsBox from './news';
import { Popover } from '../../popup/popup';
import { Dropdown } from '../../dropdown/dropdown';
import { logOut } from '../../../redux/authentication/actionCreator';
import Heading from '../../heading/heading';
import { UserAuthenticationContext } from '../../../config/auth/token_provider';
import { setDailogStatusAction, setActiveLayoutAction } from '../../../redux/pricingLayoutDailog/actionCreator';
import { login, setAuthToken } from '../../../redux/authentication/actionCreator';
import 'dotenv/config';

const AuthInfo = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const genRanHex = size => [...Array(size)].map(() => Math.floor(Math.random() * 16).toString(16)).join('');
  const [showPopover, togglePopoverView] = useState(false);
  const { user, session, isLoggedIn, isLoggingIn } = useContext(UserAuthenticationContext);
  const pricingDailog = useSelector(state => state.pricingLayoutDailogReducer);
  const userExperimentsData = useSelector(state => state.userExperimentsData);
  const currentLocation = useLocation();
  const [redirectngToBilling, setRedirectionState] = useState(false);
  const { isAuthenticate } = useSelector(state => {
    return {
      isAuthenticate: state.fb.auth.uid,
    };
  });

  const [state, setState] = useState({
    flag: 'english',
  });
  const { flag } = state;

  const SignOut = e => {
    e.preventDefault();
    // instance.logout();
    console.log('\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n 49 \n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n');
    localStorage.removeItem('authToken');
    dispatch(setAuthToken(null));
    history.push('/');
    // history.pushState
    dispatch(logOut());
  };

  const togglePricingDailog = () => {
    togglePopoverView(false);
    if (pricingDailog.pricingLayout === true) {
      dispatch(setDailogStatusAction(false));
    } else {
      dispatch(setActiveLayoutAction('pricing'));
      dispatch(setDailogStatusAction(true));
    }
  };

  const getFirstName = name => {
    const strUpper = name.replace(/[^A-Z]/g, '');
    return name.slice(0, name.indexOf(strUpper[1]));
  };

  const onTouchProfileImage = () => {
    console.log('Clicked Profile Image');
    if (showPopover === false) {
      togglePopoverView(true);
    } else {
      togglePopoverView(false);
    }
  };

  // const proceedToBilling = e => {
  //   return fetch(
  //     `https://liqural-stripe-dev.azurewebsites.net/api/StripePortal?customer_id=${user.idTokenClaims.extension_stripeId}&return_url=${window.location.href}`,
  //   )
  //     .then(response => response.json())
  //     .then(data => {
  //       console.log(data);
  //       window.location.replace(data.params.session_url);
  //     })
  //     .catch(error => console.error(error));
  // };

  const getFirstLetters = str => {
    const firstLetters = str
      .split(' ')
      .map(word => word[0])
      .join('');

    return firstLetters;
  };

  const proceedToBilling = () => {
    setRedirectionState(true);
    var currentEnviornment =
      process.env && process.env.REACT_APP_ENVIORNMENT === 'production'
        ? 'prod'
        : process.env && process.env.REACT_APP_ENVIORNMENT === 'development'
        ? 'dev'
        : 'local';

    // https://liqural-stripe-dev.azurewebsites.net/api/StripePortal
    console.log('Stripe URL : ', userExperimentsData.allUserExperimentVariables.stripe_url);
    return fetch(
      `https://liqural-stripe-dev.azurewebsites.net/api/StripePortal?customer_id=${'NOT_PROVIDED'}&env=${currentEnviornment}&azure_id=${
        user.oid
      }`,
    )
      .then(response => response.json())
      .then(data => {
        console.log(data);
        setRedirectionState(false);
        window.location.replace(data.params.session_url);
      })
      .catch(error => {
        setRedirectionState(false);
        console.error(error);
      });
  };

  const userContent = (
    <UserDropDwon>
      <div className="user-dropdwon">
        <figure className="user-dropdwon__info">
          <Avatar size="large" style={{ marginRight: '15px', backgroundColor: `#063d99` }}>
            {getFirstLetters(user.name)}
          </Avatar>
          <figcaption style={{ marginTop: '5%' }}>
            <Heading as="h5">{user.name}</Heading>
          </figcaption>
        </figure>
        <li>
          <Link
            to="/profile-settings"
            onClick={togglePricingDailog}
            style={{ display: 'flex', justifyContent: 'flex-start', fontSize: '14px', alignItems: 'center' }}
          >
            <FeatherIcon icon="user" style={{ marginRight: '20px' }} size={16} /> Profile
          </Link>
          <Link
            to="#"
            onClick={proceedToBilling}
            style={{ display: 'flex', justifyContent: 'flex-start', fontSize: '14px', alignItems: 'center' }}
          >
            <FeatherIcon icon="credit-card" style={{ marginRight: '20px' }} size={16} /> Billing
            {redirectngToBilling && (
              <PulseLoader
                color="#428cf6"
                loading
                size={11}
                aria-label="Loading Spinner"
                data-testid="loader"
                style={{ marginTop: '8px', marginLeft: '20px' }}
              />
            )}
          </Link>
        </li>
        {/* <ul className="user-dropdwon__links">
          <li>
            <Link to="#">
              <FeatherIcon icon="user" /> Profile
            </Link>
          </li>
          <li>
            <Link to="#">
              <FeatherIcon icon="settings" /> Settings
            </Link>
          </li>
          <li>
            <Link onClick={proceedToBilling} to="#">
              <FeatherIcon icon="dollar-sign" /> Billing
            </Link>
          </li>
          <li>
            <Link to="#">
              <FeatherIcon icon="users" /> Activity
            </Link>
          </li>
          <li>
            <Link to="#">
              <FeatherIcon icon="bell" /> Help
            </Link>
          </li>
        </ul> */}
        <Link className="user-dropdwon__bottomAction" onClick={SignOut} to="#">
          <FeatherIcon icon="log-out" /> Sign Out
        </Link>
      </div>
    </UserDropDwon>
  );

  const onFlagChangeHandle = value => {
    setState({
      ...state,
      flag: value,
    });
  };

  const country = (
    <NavAuth>
      <Link onClick={() => onFlagChangeHandle('english')} to="#">
        <img src={require('../../../static/img/flag/english.png')} alt="" />
        <span>English</span>
      </Link>
      <Link onClick={() => onFlagChangeHandle('germany')} to="#">
        <img src={require('../../../static/img/flag/germany.png')} alt="" />
        <span>Germany</span>
      </Link>
      <Link onClick={() => onFlagChangeHandle('spain')} to="#">
        <img src={require('../../../static/img/flag/spain.png')} alt="" />
        <span>Spain</span>
      </Link>
      <Link onClick={() => onFlagChangeHandle('turky')} to="#">
        <img src={require('../../../static/img/flag/turkey.png')} alt="" />
        <span>Turkey</span>
      </Link>
    </NavAuth>
  );

  return (
    <InfoWraper>
      {location.pathname !== '/' ? (
        <>
          {/* <Notification /> */}
          {/* <NewsBox /> */}
          {/* <Settings /> */}
          {/* <Message /> */}
        </>
      ) : (
        <></>
      )}
      <Support />
      {/* <div className="nav-author">
        <Dropdown placement="bottomRight" content={country} trigger="click">
          <Link to="#" className="head-example">
            <img src={require(`../../../static/img/flag/${flag}.png`)} alt="" />
          </Link>
        </Dropdown>
      </div> */}

      <div className="nav-author">
        <Popover placement="bottomRight" content={userContent} action="click" visible={showPopover}>
          {/* <Link to="/" className="head-example">
            <Avatar src="https://cdn0.iconfinder.com/data/icons/user-pictures/100/matureman1-512.png" />
          </Link> */}
          <Link to="/dashboard" onClick={onTouchProfileImage} className="head-example">
            <Avatar className="popover-avatar" size="large" style={{ backgroundColor: `#063d99` }}>
              {getFirstLetters(user.name)}
            </Avatar>
          </Link>
        </Popover>
      </div>
    </InfoWraper>
  );
};

export default AuthInfo;
